import React from "react";
import "./InformPanel.scss";

type SubRowHistoryTextProps = {
    action: string;
};

const SubRowHistoryText: React.FC<SubRowHistoryTextProps> = ({ action }) => {
    return (
        <div className="inform_panel__row">
            <div className="row__item">
                <div className="row__label">Information:</div>
                <div className="row__data">{action}</div>
            </div>
        </div>
    );
};

export default SubRowHistoryText;
